import {Component, OnInit} from '@angular/core';
import {APIService} from "../../services/APIService";
import {ScheduledAnnouncement} from "../../entities/server/ScheduledAnnouncement";

@Component({
  selector: 'app-announces-list',
  templateUrl: './announces-list.component.html',
  styleUrls: ['./announces-list.component.css']
})
export class AnnouncesListComponent implements OnInit {

  announcements: ScheduledAnnouncement[] = [];
  columns: string[] = ['id', 'prefix', 'message'];

  constructor(public apiService: APIService) {
  }

  ngOnInit(): void {
    this.apiService.getScheduledAnnouncements().then((a) => this.announcements = a);
  }
}
